import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: { display: 'flex', flexDirection: 'column', width: '100%' },
  label: { fontSize: 12, marginBottom: theme.spacing(0.5) },
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  picker: { flex: 1, minWidth: 0 },
  remove: { flexShrink: 0, marginTop: theme.spacing(0.5) },
  add: { alignSelf: 'flex-start' },
  helper: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5)
  },
  errorText: { color: theme.palette.error.main, marginTop: theme.spacing(0.5) }
}))

export default useStyles
